(() => {
    if (window.__zyraHomeInteractionsInstalled) return;
    window.__zyraHomeInteractionsInstalled = true;
    const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const updateControls = (track) => {
      if (!(track instanceof HTMLElement) || !track.id) return;
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      document.querySelectorAll('[aria-controls="' + track.id + '"][data-zyra-carousel-direction]').forEach((control) => {
        const direction = Number(control.dataset.zyraCarouselDirection);
        control.disabled = direction < 0 ? track.scrollLeft <= 3 : track.scrollLeft >= maxScroll - 3;
      });
    };

    document.querySelectorAll('[data-zyra-home-carousel]').forEach((track) => {
      updateControls(track);
      track.addEventListener('scroll', () => updateControls(track), { passive: true });
      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(() => updateControls(track));
        resizeObserver.observe(track);
      }
    });

    document.addEventListener('click', (event) => {
      const button = event.target instanceof Element ? event.target.closest('[data-zyra-carousel-direction][aria-controls]') : null;
      if (!button || button.disabled) return;
      const track = document.getElementById(button.getAttribute('aria-controls'));
      if (!track) return;
      const card = track.querySelector('.zyra-category-card');
      const gap = Number.parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 16;
      const distance = card ? card.getBoundingClientRect().width + gap : track.clientWidth * .8;
      track.scrollBy({ left: Number(button.dataset.zyraCarouselDirection) * distance, behavior: reducedMotion ? 'auto' : 'smooth' });
    });
  })();